// extracted by mini-css-extract-plugin
export default {"wrapper":"downloadAppCommon_wrapper__Ndsp3"};